import { SHOPPING_INFO } from "@/data/meal-plan/shopping-info";
import { formatGrams, formatNumber } from "./format";
import type { AggregatedItem } from "./shopping-aggregate";

const PLURALS: Record<string, string> = {
  cdta: "cdtas",
  cda: "cdas",
  paquete: "paquetes",
  botella: "botellas",
  lata: "latas",
  "opción": "opciones",
};

/** A Compras unit for `count` of it: "1 botella", "2 botellas"; und and tz don't change. */
export function unitLabel(unit: string, count: number): string {
  return count === 1 ? unit : (PLURALS[unit] ?? unit);
}

/**
 * A Compras line as a shopper reads it: "250 g cocido",
 * "560 g escurrido · ≈ 6 latas", "13 cdtas", "1.13 kg".
 */
export function formatShoppingAmount(item: AggregatedItem): string {
  const units = item.totalUnits > 0 ? `${formatNumber(item.totalUnits)} ${unitLabel(item.unit, item.totalUnits)}` : "";
  if (item.totalGrams <= 0) return units;
  if (units) return `${formatGrams(item.totalGrams)} + ${units}`;

  const info = SHOPPING_INFO[item.name];
  const weight = [formatGrams(item.totalGrams), info?.state].filter(Boolean).join(" ");
  if (!info?.container) return weight;
  const count = Math.ceil(item.totalGrams / info.container.grams);
  return `${weight} · ≈ ${count} ${unitLabel(info.container.unit, count)}`;
}
